import { 
  ENUM_JOB_STATUS_TECH_ASSIG,
  ENUM_JOB_STATUS_JOB_INIT,
  ENUM_JOB_STATUS_JOB_NAV_CREATED,
  ENUM_JOB_STATUS_JOB_NAV_INPROGRESS,
  ENUM_JOB_STATUS_JOB_WORK_INPROGRESS,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING,
  ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED,
} from "../../utilities";

export const BadgeServiceStatus = (props) => {
  // input
  const { status = null} = props;

  switch(status) {
    case ENUM_JOB_STATUS_TECH_ASSIG: return (
      <span className="inline-flex items-center rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-green-800 shadow-sm ring-1 ring-inset ring-green-600/20">
        Finding Partner
      </span>
    )
    case ENUM_JOB_STATUS_JOB_INIT: return (
      <span className="inline-flex items-center rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-green-800 shadow-sm ring-1 ring-inset ring-green-600/20">
        Pending Partner Action
      </span>
    )
    case ENUM_JOB_STATUS_JOB_NAV_CREATED:
    case ENUM_JOB_STATUS_JOB_NAV_INPROGRESS: return (
      <span className="inline-flex items-center rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-green-800 shadow-sm ring-1 ring-inset ring-green-600/20">
        Navigate to Premise
      </span>
    )
    case ENUM_JOB_STATUS_JOB_WORK_INPROGRESS: return (
      <span className="inline-flex items-center rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-green-800 shadow-sm ring-1 ring-inset ring-green-600/20">
        Working
      </span>
    )
    case ENUM_JOB_STATUS_JOB_COMPLETED_PAY_PENDING: return (
      <span className="inline-flex items-center rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-green-800 shadow-sm ring-1 ring-inset ring-green-600/20">
        Pending Sharing Payment
      </span>
    )
    case ENUM_JOB_STATUS_JOB_COMPLETED_PAY_COMPLETED: return (
      <span className="inline-flex items-center rounded-md bg-teal-50 px-2 py-1 text-xs font-medium text-green-800 shadow-sm ring-1 ring-inset ring-green-600/20">
        Completed
      </span>
    )
    default: return (
      <span className="inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 shadow-sm ring-1 ring-inset ring-gray-500/10">
        {status ? status : 'Unknown'}
      </span>
    )
  }
}